import React, {Fragment} from "react";
import Tooltip from '@mui/material/Tooltip';

const WspolnotaRaportZbiorowyTHead = ( props ) => {

    const { listaMsc, visible, czyRok, rok } = props;

    const kolumnyMiesiace = listaMsc?.map( (e, i) => {

        if (!visible) {
            return (
                <Fragment key={i}>
                </Fragment>
            )
        } else {
            return (
                <Fragment key={i}>
                    <th>
                        należności
                    </th>
                    <th>
                        wpłaty
                    </th>
                    <th>
                        saldo
                    </th>
                </Fragment>
            )
        }
    })      

    const thDaty = listaMsc?.map( (e,i) => {
        if (!visible) {
            return (
                <Fragment key={i}></Fragment>
            )
        } else {
            return (
                <th 
                    colSpan={3} 
                    style={{textAlign: "center"}}
                    key={i}
                >
                    {e}  
                </th>
            )
        }
    })

    const thRok = czyRok && (<th style={{backgroundColor: "var(--podswietlenie)"}}>{`Na koniec ${rok}`}</th>); 
    const thRokCols = czyRok && (<Fragment>
        <th style={{backgroundColor: "var(--podswietlenie)"}}>razem</th>
    </Fragment>)

    return (
        <thead>
            <tr key={-1}>
                <th rowSpan={2} style={{border: "1px solid black"}}>
                    Mieszkaniec
                </th>
                <th rowSpan={2} style={{border: "1px solid black"}}>
                    Adres
                </th>
                <th rowSpan={2} style={{border: "1px solid black"}}>
                    Saldo<br/>komornik
                </th>
                { thRok }
                {
                    visible ? (
                        <Fragment>
                            {thDaty}
                            <th
                                colSpan={3} 
                                style={{textAlign: "center", backgroundColor: "var(--podswietlenie)"}}>
                                Podsumowanie
                            </th>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <th
                                colSpan={3} 
                                style={{textAlign: "center", backgroundColor: "var(--podswietlenie)"}}>
                                Podsumowanie
                            </th>
                        </Fragment>
                    )
                }
            </tr>

            {
                <tr     
                    key={0}
                    className="second"
                >
                    {thRokCols}
                    {kolumnyMiesiace}
                    <th style={{backgroundColor: "var(--podswietlenie)"}}>
                        <Tooltip
                            title="należności w wybranym zakresie"
                            placement='top'
                        >
                            <u>należności</u>
                        </Tooltip>
                    </th>
                    <th style={{backgroundColor: "var(--podswietlenie)"}}>
                        <Tooltip
                            title="wpłaty w wybranym zakresie"
                            placement='top'
                        >
                            <u>wpłaty</u>
                        </Tooltip>
                    </th>
                    <th style={{backgroundColor: "var(--podswietlenie)"}}>
                        <Tooltip
                            title="saldo całkowite od początku założenia grupy"
                            placement='top'
                        >
                            <u>saldo</u>
                        </Tooltip>
                    </th>
                </tr>
            }
        </thead>
    ) 

}

export default WspolnotaRaportZbiorowyTHead;